module.exports = __webpack_public_path__ + "img/FATIMA NECKLACE BN.54cc3b8.svg";